<template>
  <validation-provider
    #default="{ errors }"
    name="Proje Adı"
    rules="required"
  >
    <b-form-group
      label="Proje Adı"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="dataItem.title"
        placeholder="Proje Adı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'ProjectTitleText',
  components: {
    ValidationProvider,
    BFormGroup,
    BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
}
</script>
